var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 79.2,
    cy: 62.3,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,83.9c-1.9-1.3-4-2.8-8-2.8c-4,0-6.1,1.5-8,2.8c-1.5,1.1-2.8,2-5.2,2.3c0.1-0.1,0.2-0.1,0.2-0.2c2-2,2-5.3,0-7.3 c-1-1-2.3-1.5-3.6-1.5H74.1L50.1,53.1c-1.7-1.7-4.5-2-6.6-0.6L26.6,64.2c-2.3,1.6-2.9,4.8-1.3,7.2c1.6,2.3,4.8,2.9,7.2,1.3 l13.4-9.3l7.7,7.7l-17.3,12c-0.4,0.3-0.7,0.5-1.1,0.8c-1.7,1.2-3.2,2.3-6.4,2.3s-4.7-1.1-6.4-2.3c-1.9-1.3-4-2.8-8-2.8 s-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3v2.7c4,0,6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8 s6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8s6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3 s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8c4,0,6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8 c4,0,6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3c3.2,0,4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8v-2.7C140.8,86.2,139.3,85.1,137.6,83.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.4,86.2c-0.1,0-0.2,0-0.3,0C116.3,86.2,116.4,86.2,116.4,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,86.2c0,0-0.1,0-0.1,0C115.7,86.2,115.8,86.2,115.8,86.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwim);
export default __webpack_public_path__ + "static/media/swim.b8b1efd118e946af7b0ecfc3d480e362.svg";
export { ForwardRef as ReactComponent };